"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthToken = exports.postRefreshTasks = exports.logoutUser = exports.isOnboardingPage = exports.getAuthToken = exports.QUERY_PARAM_USER_ID = exports.QUERY_PARAM_ORG_INVITE = exports.QUERY_PARAM_MODAL = exports.QUERY_PARAM_FORCE_AUTH = exports.QUERY_PARAM_COUPON = exports.AUTH_STRATEGY_GOOGLE = exports.AUTH_STRATEGY_FACEBOOK = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _urlBuilderService = require("@zorba-shared/core/Services/urlBuilderService");

var _clientService = require("./clientService");

var _requestService = require("./requestService");

var QUERY_PARAM_FORCE_AUTH = "force_auth";
exports.QUERY_PARAM_FORCE_AUTH = QUERY_PARAM_FORCE_AUTH;
var QUERY_PARAM_USER_ID = "uid";
exports.QUERY_PARAM_USER_ID = QUERY_PARAM_USER_ID;
var QUERY_PARAM_MODAL = "modal";
exports.QUERY_PARAM_MODAL = QUERY_PARAM_MODAL;
var QUERY_PARAM_ORG_INVITE = "org_invite";
exports.QUERY_PARAM_ORG_INVITE = QUERY_PARAM_ORG_INVITE;
var QUERY_PARAM_COUPON = "coupon";
exports.QUERY_PARAM_COUPON = QUERY_PARAM_COUPON;
var AUTH_STRATEGY_FACEBOOK = "facebook";
exports.AUTH_STRATEGY_FACEBOOK = AUTH_STRATEGY_FACEBOOK;
var AUTH_STRATEGY_GOOGLE = "google";
exports.AUTH_STRATEGY_GOOGLE = AUTH_STRATEGY_GOOGLE;
var COOKIE_NAME_AUTH_TOKEN = "x-access-token";

var setAuthToken = function setAuthToken(token) {
  (0, _clientService.setCookie)(COOKIE_NAME_AUTH_TOKEN, token, 365);
};

exports.setAuthToken = setAuthToken;

var getAuthToken = function getAuthToken() {
  return (0, _clientService.getCookie)(COOKIE_NAME_AUTH_TOKEN);
};

exports.getAuthToken = getAuthToken;

var logoutUser = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var shouldRedirectToLogin,
        res,
        auth2,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            shouldRedirectToLogin = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            _context.next = 3;
            return (0, _requestService.postRequest)("/auth/logout");

          case 3:
            res = _context.sent;

            try {
              auth2 = window.gapi.auth2.getAuthInstance();

              if (auth2 != null) {
                auth2.signOut().then(auth2.disconnect().then(function (e) {}));
              }
            } catch (e) {}

            (0, _clientService.removeCookie)(COOKIE_NAME_AUTH_TOKEN);

            if (shouldRedirectToLogin) {
              window.location.href = (0, _urlBuilderService.buildLoginUrl)();
            } else {
              window.location.reload();
            }

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function logoutUser() {
    return _ref.apply(this, arguments);
  };
}();

exports.logoutUser = logoutUser;

var postRefreshTasks = function postRefreshTasks() {
  var orgInvite = (0, _clientService.getQueryParam)(QUERY_PARAM_ORG_INVITE);

  if (orgInvite) {
    (0, _clientService.setCookie)(QUERY_PARAM_ORG_INVITE, orgInvite, 1);
  }

  var coupon = (0, _clientService.getQueryParam)(QUERY_PARAM_COUPON);

  if (coupon) {
    (0, _clientService.setCookie)(QUERY_PARAM_COUPON, coupon, 1);
  }
};

exports.postRefreshTasks = postRefreshTasks;

var isOnboardingPage = function isOnboardingPage() {
  return (0, _clientService.getWindow)().location.pathname.startsWith("/o/onboarding");
};

exports.isOnboardingPage = isOnboardingPage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJRVUVSWV9QQVJBTV9GT1JDRV9BVVRIIiwiUVVFUllfUEFSQU1fVVNFUl9JRCIsIlFVRVJZX1BBUkFNX01PREFMIiwiUVVFUllfUEFSQU1fT1JHX0lOVklURSIsIlFVRVJZX1BBUkFNX0NPVVBPTiIsIkFVVEhfU1RSQVRFR1lfRkFDRUJPT0siLCJBVVRIX1NUUkFURUdZX0dPT0dMRSIsIkNPT0tJRV9OQU1FX0FVVEhfVE9LRU4iLCJzZXRBdXRoVG9rZW4iLCJ0b2tlbiIsInNldENvb2tpZSIsImdldEF1dGhUb2tlbiIsImdldENvb2tpZSIsImxvZ291dFVzZXIiLCJzaG91bGRSZWRpcmVjdFRvTG9naW4iLCJwb3N0UmVxdWVzdCIsInJlcyIsImF1dGgyIiwid2luZG93IiwiZ2FwaSIsImdldEF1dGhJbnN0YW5jZSIsInNpZ25PdXQiLCJ0aGVuIiwiZGlzY29ubmVjdCIsImUiLCJyZW1vdmVDb29raWUiLCJsb2NhdGlvbiIsImhyZWYiLCJidWlsZExvZ2luVXJsIiwicmVsb2FkIiwicG9zdFJlZnJlc2hUYXNrcyIsIm9yZ0ludml0ZSIsImdldFF1ZXJ5UGFyYW0iLCJjb3Vwb24iLCJpc09uYm9hcmRpbmdQYWdlIiwiZ2V0V2luZG93IiwicGF0aG5hbWUiLCJzdGFydHNXaXRoIl0sInNvdXJjZXMiOlsiYXV0aFNlcnZpY2UuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRMb2dpblVybCB9IGZyb20gXCJAem9yYmEtc2hhcmVkL2NvcmUvU2VydmljZXMvdXJsQnVpbGRlclNlcnZpY2VcIjtcbmltcG9ydCB7XG4gIGdldENvb2tpZSxcbiAgZ2V0UXVlcnlQYXJhbSxcbiAgZ2V0V2luZG93LFxuICByZW1vdmVDb29raWUsXG4gIHNldENvb2tpZVxufSBmcm9tIFwiLi9jbGllbnRTZXJ2aWNlXCI7XG5pbXBvcnQgeyBwb3N0UmVxdWVzdCB9IGZyb20gXCIuL3JlcXVlc3RTZXJ2aWNlXCI7XG5cbmV4cG9ydCBjb25zdCBRVUVSWV9QQVJBTV9GT1JDRV9BVVRIID0gXCJmb3JjZV9hdXRoXCI7XG5leHBvcnQgY29uc3QgUVVFUllfUEFSQU1fVVNFUl9JRCA9IFwidWlkXCI7XG5leHBvcnQgY29uc3QgUVVFUllfUEFSQU1fTU9EQUwgPSBcIm1vZGFsXCI7XG5leHBvcnQgY29uc3QgUVVFUllfUEFSQU1fT1JHX0lOVklURSA9IFwib3JnX2ludml0ZVwiO1xuZXhwb3J0IGNvbnN0IFFVRVJZX1BBUkFNX0NPVVBPTiA9IFwiY291cG9uXCI7XG5cbmV4cG9ydCBjb25zdCBBVVRIX1NUUkFURUdZX0ZBQ0VCT09LID0gXCJmYWNlYm9va1wiO1xuZXhwb3J0IGNvbnN0IEFVVEhfU1RSQVRFR1lfR09PR0xFID0gXCJnb29nbGVcIjtcblxuY29uc3QgQ09PS0lFX05BTUVfQVVUSF9UT0tFTiA9IFwieC1hY2Nlc3MtdG9rZW5cIjtcblxuZXhwb3J0IGNvbnN0IHNldEF1dGhUb2tlbiA9ICh0b2tlbikgPT4ge1xuICBzZXRDb29raWUoQ09PS0lFX05BTUVfQVVUSF9UT0tFTiwgdG9rZW4sIDM2NSk7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0QXV0aFRva2VuID0gKCkgPT4gZ2V0Q29va2llKENPT0tJRV9OQU1FX0FVVEhfVE9LRU4pO1xuXG5leHBvcnQgY29uc3QgbG9nb3V0VXNlciA9IGFzeW5jIChzaG91bGRSZWRpcmVjdFRvTG9naW4gPSBmYWxzZSkgPT4ge1xuICBjb25zdCByZXMgPSBhd2FpdCBwb3N0UmVxdWVzdChcIi9hdXRoL2xvZ291dFwiKTtcbiAgdHJ5IHtcbiAgICBjb25zdCBhdXRoMiA9IHdpbmRvdy5nYXBpLmF1dGgyLmdldEF1dGhJbnN0YW5jZSgpO1xuICAgIGlmIChhdXRoMiAhPSBudWxsKSB7XG4gICAgICBhdXRoMi5zaWduT3V0KCkudGhlbihhdXRoMi5kaXNjb25uZWN0KCkudGhlbigoZSkgPT4ge30pKTtcbiAgICB9XG4gIH0gY2F0Y2ggKGUpIHt9XG4gIHJlbW92ZUNvb2tpZShDT09LSUVfTkFNRV9BVVRIX1RPS0VOKTtcbiAgaWYgKHNob3VsZFJlZGlyZWN0VG9Mb2dpbikge1xuICAgIHdpbmRvdy5sb2NhdGlvbi5ocmVmID0gYnVpbGRMb2dpblVybCgpO1xuICB9IGVsc2Uge1xuICAgIHdpbmRvdy5sb2NhdGlvbi5yZWxvYWQoKTtcbiAgfVxufTtcblxuZXhwb3J0IGNvbnN0IHBvc3RSZWZyZXNoVGFza3MgPSAoKSA9PiB7XG4gIGNvbnN0IG9yZ0ludml0ZSA9IGdldFF1ZXJ5UGFyYW0oUVVFUllfUEFSQU1fT1JHX0lOVklURSk7XG5cbiAgaWYgKG9yZ0ludml0ZSkge1xuICAgIHNldENvb2tpZShRVUVSWV9QQVJBTV9PUkdfSU5WSVRFLCBvcmdJbnZpdGUsIDEpO1xuICB9XG5cbiAgY29uc3QgY291cG9uID0gZ2V0UXVlcnlQYXJhbShRVUVSWV9QQVJBTV9DT1VQT04pO1xuICBpZiAoY291cG9uKSB7XG4gICAgc2V0Q29va2llKFFVRVJZX1BBUkFNX0NPVVBPTiwgY291cG9uLCAxKTtcbiAgfVxufTtcblxuZXhwb3J0IGNvbnN0IGlzT25ib2FyZGluZ1BhZ2UgPSAoKSA9PlxuICBnZXRXaW5kb3coKS5sb2NhdGlvbi5wYXRobmFtZS5zdGFydHNXaXRoKFwiL28vb25ib2FyZGluZ1wiKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQU9BOztBQUVPLElBQU1BLHNCQUFzQixHQUFHLFlBQS9COztBQUNBLElBQU1DLG1CQUFtQixHQUFHLEtBQTVCOztBQUNBLElBQU1DLGlCQUFpQixHQUFHLE9BQTFCOztBQUNBLElBQU1DLHNCQUFzQixHQUFHLFlBQS9COztBQUNBLElBQU1DLGtCQUFrQixHQUFHLFFBQTNCOztBQUVBLElBQU1DLHNCQUFzQixHQUFHLFVBQS9COztBQUNBLElBQU1DLG9CQUFvQixHQUFHLFFBQTdCOztBQUVQLElBQU1DLHNCQUFzQixHQUFHLGdCQUEvQjs7QUFFTyxJQUFNQyxZQUFZLEdBQUcsU0FBZkEsWUFBZSxDQUFDQyxLQUFELEVBQVc7RUFDckMsSUFBQUMsd0JBQUEsRUFBVUgsc0JBQVYsRUFBa0NFLEtBQWxDLEVBQXlDLEdBQXpDO0FBQ0QsQ0FGTTs7OztBQUlBLElBQU1FLFlBQVksR0FBRyxTQUFmQSxZQUFlO0VBQUEsT0FBTSxJQUFBQyx3QkFBQSxFQUFVTCxzQkFBVixDQUFOO0FBQUEsQ0FBckI7Ozs7QUFFQSxJQUFNTSxVQUFVO0VBQUEseUZBQUc7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO01BQUE7UUFBQTtVQUFBO1lBQU9DLHFCQUFQLDJEQUErQixLQUEvQjtZQUFBO1lBQUEsT0FDTixJQUFBQywyQkFBQSxFQUFZLGNBQVosQ0FETTs7VUFBQTtZQUNsQkMsR0FEa0I7O1lBRXhCLElBQUk7Y0FDSUMsS0FESixHQUNZQyxNQUFNLENBQUNDLElBQVAsQ0FBWUYsS0FBWixDQUFrQkcsZUFBbEIsRUFEWjs7Y0FFRixJQUFJSCxLQUFLLElBQUksSUFBYixFQUFtQjtnQkFDakJBLEtBQUssQ0FBQ0ksT0FBTixHQUFnQkMsSUFBaEIsQ0FBcUJMLEtBQUssQ0FBQ00sVUFBTixHQUFtQkQsSUFBbkIsQ0FBd0IsVUFBQ0UsQ0FBRCxFQUFPLENBQUUsQ0FBakMsQ0FBckI7Y0FDRDtZQUNGLENBTEQsQ0FLRSxPQUFPQSxDQUFQLEVBQVUsQ0FBRTs7WUFDZCxJQUFBQywyQkFBQSxFQUFhbEIsc0JBQWI7O1lBQ0EsSUFBSU8scUJBQUosRUFBMkI7Y0FDekJJLE1BQU0sQ0FBQ1EsUUFBUCxDQUFnQkMsSUFBaEIsR0FBdUIsSUFBQUMsZ0NBQUEsR0FBdkI7WUFDRCxDQUZELE1BRU87Y0FDTFYsTUFBTSxDQUFDUSxRQUFQLENBQWdCRyxNQUFoQjtZQUNEOztVQWJ1QjtVQUFBO1lBQUE7UUFBQTtNQUFBO0lBQUE7RUFBQSxDQUFIOztFQUFBLGdCQUFWaEIsVUFBVTtJQUFBO0VBQUE7QUFBQSxHQUFoQjs7OztBQWdCQSxJQUFNaUIsZ0JBQWdCLEdBQUcsU0FBbkJBLGdCQUFtQixHQUFNO0VBQ3BDLElBQU1DLFNBQVMsR0FBRyxJQUFBQyw0QkFBQSxFQUFjN0Isc0JBQWQsQ0FBbEI7O0VBRUEsSUFBSTRCLFNBQUosRUFBZTtJQUNiLElBQUFyQix3QkFBQSxFQUFVUCxzQkFBVixFQUFrQzRCLFNBQWxDLEVBQTZDLENBQTdDO0VBQ0Q7O0VBRUQsSUFBTUUsTUFBTSxHQUFHLElBQUFELDRCQUFBLEVBQWM1QixrQkFBZCxDQUFmOztFQUNBLElBQUk2QixNQUFKLEVBQVk7SUFDVixJQUFBdkIsd0JBQUEsRUFBVU4sa0JBQVYsRUFBOEI2QixNQUE5QixFQUFzQyxDQUF0QztFQUNEO0FBQ0YsQ0FYTTs7OztBQWFBLElBQU1DLGdCQUFnQixHQUFHLFNBQW5CQSxnQkFBbUI7RUFBQSxPQUM5QixJQUFBQyx3QkFBQSxJQUFZVCxRQUFaLENBQXFCVSxRQUFyQixDQUE4QkMsVUFBOUIsQ0FBeUMsZUFBekMsQ0FEOEI7QUFBQSxDQUF6QiJ9